import JobExpLevels from 'app/assets/jsons/JobExpLevel.json';

export function GetJobExpLevels() {
  const data = JobExpLevels.jobExpLevels;
  return data;
}
